/** Nível “Financeiro” para páginas do módulo financeiro. */
export const BREADCRUMB_FINANCEIRO = [{ link: '', label: 'Financeiro' }];
